import swapShopifyProduct from "./swapShopifyProduct"
import swapClassData from "./swapClassData"

const swapProductsAndClasses = (elements, shopifyProducts, classes) =>
  elements
    .map((element) => {
      if (element.type === "product" && element.productId) {
        return swapShopifyProduct({
          item: element,
          type: element.type,
          shopifyProducts,
        })
      }

      if (
        element.type === "product" &&
        (element.classId ||
          element.url?.match(/mindbodygreen\.com\/(classes|coaching)\/[a-zA-Z0-9\-]+/))
      ) {
        element.isClass = true

        if (!element.buttonText) {
          element.buttonText = "Learn More"
        }

        return swapClassData({
          item: element,
          type: element.type,
          classes,
        })
      }

      if (element.type === "shop") {
        element.products = element.products
          .map((product) => {
            if (product?.productId) {
              return swapShopifyProduct({
                item: product,
                type: element.type,
                shopifyProducts,
              })
            }
            return product
          })
          .filter(Boolean)
      }

      if (element.type === "review") {
        element.items = element.items
          .map((item) => {
            if (item.productId) {
              return swapShopifyProduct({
                item,
                type: element.type,
                shopifyProducts,
              })
            }
            return item
          })
          .filter(Boolean)
      }

      return element
    })
    .filter(Boolean)

export default swapProductsAndClasses
